import * as msal from 'msal'
import admin from "@/apiCallers/promise_handler_db/admin";

// MSAL object used for signing in users with MS identity platform
let msalApp
const LOGIN_SCOPES = [ 'user.read','calendars.readwrite',"mail.send", "mail.send.shared", 'sites.readwrite.all','openid', 'profile', 'mail.readwrite','files.readwrite.all', 'group.readwrite.all','sites.fullcontrol.all' ]

// Check if this window was opened as a pop-up from our app
const isChildPopup = () => {
  try {
    return window.opener &&
           window.opener !== window &&
           window.opener.location.origin === window.location.origin &&
           typeof window.opener.__authBridge === 'object'
  } catch (e) {
    return false
  }
}

export default {
  //
  // Configure with clientId or empty string/null to set in "demo" mode
  //
  async configure(clientId) {
    // Can only call configure once
    if (msalApp) { return }

    // If no clientId provided then create a mock MSAL UserAgentApplication
    // Allows us to run without Azure AD for demos & local dev
    // if (!clientId) {
    //   console.log('### Azure AD sign-in: disabled. Will run in demo mode with dummy demo@example.net account')
      // Stub out all the functions we call and return static dummy user where required
      // Use localStorage to simulate MSAL caching and logging out
    //   msalApp = {
    //     clientId: null,

    //     loginPopup() {
    //       localStorage.setItem('dummyAccount', JSON.stringify(dummyUser))
    //       return new Promise((resolve) => resolve())
    //     },
    //     logout() {
    //       localStorage.removeItem('dummyAccount')
    //       window.location.href = '/'
    //       return new Promise((resolve) => resolve())
    //     },
    //     acquireTokenSilent() {
    //       return new Promise((resolve) => resolve())
    //     },
    //     cacheStorage: {
    //       clear() {
    //         localStorage.removeItem('dummyAccount')
    //       }
    //     },
    //     getAccount() {
    //       return JSON.parse(localStorage.getItem('dummyAccount'))
    //     }
    //   }
    //   return
    // }

    const config = {
      auth: {
        clientId: "e18485dc-e787-4b9b-ac91-5f6726838db8",
        tenantId: "cbefa5d6-bd94-406c-a0fa-39e7443961a3", 
        authority: "https://login.microsoftonline.com/cbefa5d6-bd94-406c-a0fa-39e7443961a3",
        redirectUri: window.location.origin,
        validateAuthority: true,
        
      },
      cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false,
      },
      // Only uncomment when you *really* need to debug what is going on in MSAL
      /* system: {
        logger: new msal.Logger(
          (logLevel, msg) => { console.log(msg) },
          {
            level: msal.LogLevel.Verbose
          }
        )
      } */
    }
    // console.log('### Azure AD sign-in: enabled\n', config)

    // Create our shared/static MSAL app object
    msalApp = new msal.UserAgentApplication(config);
    msalApp.handleRedirectCallback(async (error, response) => {
      if (response) {
        const token = await this.acquireToken(process.env.GRAPH_SCOPES);
        // await admin.logUserLogin(token);
      }
      if(error){
        console.log("UNSUCCESSFUL LOGIN")
      }
    })

    // Expose auth bridge for child pop-up windows to access
    window.__authBridge = {
      getUser: () => msalApp.getAccount(),
      acquireToken: async (scopes = LOGIN_SCOPES) => {
        const accessTokenRequest = { scopes }
        try {
          const tokenResp = await msalApp.acquireTokenSilent(accessTokenRequest)
          return tokenResp.accessToken
        } catch (err) {
          const tokenResp = await msalApp.acquireTokenPopup(accessTokenRequest)
          return tokenResp.accessToken
        }
      },
      isAuthenticated: () => !!msalApp.getAccount()
    }
  },

  //
  // Return the configured client id
  //
  clientId() {
    if (!msalApp) { return null }

    return msalApp.clientId
  },

  //
  // Login a user with a popup
  //
  async login() {
    if (!msalApp) { return }

    await msalApp.loginRedirect({
      scopes: LOGIN_SCOPES,
      prompt: 'select_account',
      extraQueryParameters: { kmsi: 'false' }
    }).then(async ()=>
      location.reload()
    )
  },
  async popupLogin() {
    if (!msalApp) { return }

    await msalApp.loginPopup({
      scopes: LOGIN_SCOPES,
      prompt: 'select_account',
      extraQueryParameters: { kmsi: 'false' }
    }).then(async()=>
        location.reload()
    )
  },

  //
  // Logout any stored user
  //
  async logout() {
    if (!msalApp) { return }

    await msalApp.logout()
  },

  //
  // Call to get user, probably cached and stored locally by MSAL
  // If this is a child pop-up, get user from parent window
  //
  user() {
    // Check if we're a child pop-up with access to parent's auth
    if (isChildPopup()) {
      return window.opener.__authBridge.getUser()
    }

    if (!msalApp) { return null }

    return msalApp.getAccount()
  },

  //
  // Call through to acquireTokenSilent or acquireTokenPopup
  // If this is a child pop-up, acquire token through parent window
  //
  async acquireToken(scopes = [ 'user.read' ]) {
    // Check if we're a child pop-up with access to parent's auth
    if (isChildPopup()) {
      return await window.opener.__authBridge.acquireToken(scopes)
    }

    if (!msalApp) { return null }

    // Set scopes for token request
    const accessTokenRequest = {
      scopes : LOGIN_SCOPES
    }

    let tokenResp
    try {
      // 1. Try to acquire token silently
      tokenResp = await msalApp.acquireTokenSilent(accessTokenRequest)
      //console.log('### MSAL acquireTokenSilent was successful')
    } catch (err) {
      // 2. Silent process might have failed so try via popup
      tokenResp = await msalApp.acquireTokenPopup(accessTokenRequest)
      //console.log('### MSAL acquireTokenPopup was successful')
    }

    // Just in case check, probably never triggers
    if (!tokenResp.accessToken) {
      throw new Error('### accessToken not found in response, that\'s bad')
    }
    return tokenResp.accessToken
  },

  //
  // Clear any stored/cached user
  //
  clearLocal() {
    if (msalApp) {
      msalApp.cacheStorage.clear()
    }
  },

  //
  // Check if current window is authenticated (directly or via opener)
  //
  isAuthenticated() {
    if (isChildPopup()) {
      return window.opener.__authBridge.isAuthenticated()
    }
    return !!this.user()
  },

  //
  // Check if this window is a child pop-up with inherited auth
  //
  isChildPopup() {
    return isChildPopup()
  },

  //
  // Open an authenticated pop-up window
  // The child window will automatically inherit auth from this window
  //
  openAuthenticatedPopup(url, name = '_blank', features = '') {
    return window.open(url, name, features)
  }
}